// src/components/Tabs.tsx
import React from 'react';

export interface Tab {
  label: string;
  content: React.ReactElement;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="mt-4">
      <div className="flex border-b border-gray-300">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`px-4 py-2 font-medium text-sm border-b-2 transition duration-200 ${
              activeTab === tab.label
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-600 hover:text-blue-500'
            }`}
            onClick={() => onTabChange(tab.label)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="mt-4">{tabs.find((tab) => tab.label === activeTab)?.content}</div>
    </div>
  );
};

export default Tabs;
